// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__27PvY","content":"styles_content__1VPNL","selectAll":"styles_selectAll__3DfCl"};